import { useMemo, useState } from 'react';

export type Option = { id: string; label: string; subtitle?: string };

export default function SearchSelect({ options, placeholder, onSelect }: { options: Option[]; placeholder?: string; onSelect: (opt: Option | null) => void; }) {
  const [q, setQ] = useState('');
  const filtered = useMemo(() => {
    const s = q.trim().toLocaleLowerCase('tr');
    if (!s) return options.slice(0, 50);
    return options.filter(o => (o.label + ' ' + (o.subtitle ?? '')).toLocaleLowerCase('tr').includes(s)).slice(0, 50);
  }, [q, options]);

  return (
    <div className="w-full">
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={placeholder ?? 'Öğrenci, sınıf, şube ara...'}
        className="w-full rounded-md border bg-white px-3 py-2 text-sm outline-none ring-0 focus:border-slate-400"
      />
      <div className="mt-2 max-h-64 overflow-auto rounded-md border bg-white">
        {filtered.length === 0 && (
          <div className="px-3 py-2 text-sm text-slate-500">Sonuç yok</div>
        )}
        {filtered.map((o) => (
          <button
            key={o.id}
            onClick={() => onSelect(o)}
            className="flex w-full items-center justify-between px-3 py-2 text-left text-sm hover:bg-slate-50"
          >
            <span className="font-medium text-slate-800">{o.label}</span>
            {o.subtitle && <span className="text-xs text-slate-500">{o.subtitle}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}


